module.exports = __webpack_public_path__ + "static/media/DroneYellowMap.f5038021.svg";